package fyi.moko.hotpl.ui.home

import androidx.compose.runtime.Composable

@Composable
actual fun rememberLocationPermissionRequest(onResult: (Boolean) -> Unit): LocationPermissionRequester {
    return LocationPermissionRequester {
        onResult(true)
    }
}
